const FETCH_USER_INFO = 'core/userInfo/FETCH_USER_INFO';
const FETCH_USER_INFO_COMPLETED = 'core/userInfo/FETCH_USER_INFO_COMPLETED';
const FETCH_USER_INFO_FAILED = 'core/userInfo/FETCH_USER_INFO_FAILED';

const ACCEPT_TERMS_CONDITIONS = 'core/userInfo/ACCEPT_TERMS_CONDITIONS';
const ACCEPT_TERMS_CONDITIONS_COMPLETED = 'core/userInfo/ACCEPT_TERMS_CONDITIONS_COMPLETED';
const ACCEPT_TERMS_CONDITIONS_FAILED = 'core/userInfo/ACCEPT_TERMS_CONDITIONS_FAILED';

const MASK_USER = 'core/userInfo/MASK_USER';
const NOT_MASK_USER = 'core/userInfo/NOT_MASK_USER';
const USER_FROM_APP = 'core/userInfo/USER_FROM_APP';
const SHOW_LOGIN = 'core/userInfo/SHOW_LOGIN';

export {
  FETCH_USER_INFO,
  FETCH_USER_INFO_COMPLETED,
  FETCH_USER_INFO_FAILED,
  MASK_USER,
  NOT_MASK_USER,
  ACCEPT_TERMS_CONDITIONS,
  ACCEPT_TERMS_CONDITIONS_COMPLETED,
  ACCEPT_TERMS_CONDITIONS_FAILED,
  USER_FROM_APP,
  SHOW_LOGIN
};
